import { LoadableStatus } from '@aiwyn/shared';
import { CxpDeliverableDetail } from '../models';

export interface CxpDeliverableDetailStateModel {
  // Navigation IDs (synced from route-params service)
  selectedDeliverableId: number | null;

  // Core data
  status: LoadableStatus;
  detail: CxpDeliverableDetail | null;
}

export const DEFAULT_CXP_DELIVERABLE_DETAIL_STATE: CxpDeliverableDetailStateModel = {
  selectedDeliverableId: null,
  status: LoadableStatus.DEFAULT,
  detail: null,
};
